/* ==========================================================================
   MSearcherFlight > Client > validation
   ========================================================================= */

/* Modules */
const { getAirportByDestination } = require('./services');
const { suscriptionDates } = require('./transactions');

function validate(instance) {
    const result = {
        success: true,
        fieldsError: []
    };

    if (instance.location[0].get().content !== undefined && instance.location[0].input.value === '') {
        instance.location[0].input.set(instance.location[0].get().content);
        instance.location[0].input.setActive();
    }

    if (instance.location[0].get().content === undefined || instance.location[0].input.value === '') {
        result.success = false;
        result.fieldsError.push(instance.location[0]);
        instance.location[0].setError();
    }

    if (instance.location[1].get().content === undefined || instance.location[1].value === '') {
        result.success = false;
        result.fieldsError.push(instance.location[1]);
        instance.location[1].setError();
    }

    validateCalendar(instance);

    return result;
}

function validateCalendar(instance) {
    const ref = instance;

    if (instance.calendar.get().length !== 0) {
        return;
    }

    ref.success = false;
    instance.fieldsError.push(instance.calendar);
    instance.calendar.input.setError();
}

function validationOrigin(instance) {
    const result = {
        success: true,
        fieldsError: []
    };

    if (instance.location[0].get().content !== undefined && instance.location[0].input.value !== '') {
        instance.location[0].setValid();
    }

    return result;
}

function validationDestination(instance) {
    const result = {
        success: true,
        fieldsError: []
    };

    if (instance.location[1].get().content !== undefined && instance.location[0].input.value !== '') {
        instance.location[1].setValid();
    }

    return result;
}

function validateLocation(instance) {
    const inst = instance;
    const { location = [] } = inst;

    if (!location.length) return;

    inst.subscriptionLocation = getAirportByDestination(inst).subscribe({
        next: response => {
            const { code } = response;

            const { value: valueOrigin } = location[0];

            if (code !== valueOrigin) {
                validationDestination(instance);

                // operativeEventCallback(instance);
                suscriptionDates(instance);
                instance.submit.element.classList.remove('is-disabled');

                instance.location[1].element.classList.remove('has-error');
                instance.location[1].input.element.classList.remove('has-error');

                return;
            }

            instance.location[1].setError();
        },
        error: err => console.error(`${'Error API Packages Discounts'}${err}`)
    });
}

module.exports = {
    validate,
    validationOrigin,
    validationDestination,
    validateLocation
};
